module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/reduxsauce/node_modules/ramda/src/internal/_isTransformer.js
// module id = ux+Y
// module chunks = 0